module.exports = __webpack_public_path__ + "media/images/partners/1-ed02363b65156e4d256e57669b9f36a6.png";